import { IHistoryIsEmptyLang } from '../../../types/lang'
import { EHistoryIsEmpty } from '../../../types'

export const historyIsEmptyLang: IHistoryIsEmptyLang = {
	history_is_empty: {
		[EHistoryIsEmpty.NotEmpty]: 'Not Empty_ua',
		[EHistoryIsEmpty.Empty]: 'Empty_ua',
	}
}